module.exports = __webpack_public_path__ + "static/media/io.7fc155e7.svg";